import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks";
import { httpClient } from "@/lib/http";
import { CompanyUser, HttpResponse } from "@/types";

export function useGetCompanyUsersForSettings() {
  const currentCompanyId = useCurrentCompanyId();

  return useQuery({
    queryKey: ["settings/company-users", currentCompanyId],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/settings/company-users`;
      const res = await httpClient.get<
        CompanyUser[],
        HttpResponse<CompanyUser[]>
      >(path);
      return res.data;
    },
  });
}
